import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import {
  getLoginUserDetails,
  isOnboardingCompleteFromUser,
} from '../utils/onboarding.util';
import { getEssDashboardRoute } from 'src/app/environments/environment-host';

@Injectable({ providedIn: 'root' })
export class OnboardingAccessGuard {
  constructor(private router: Router) {}

  canActivate(): boolean | UrlTree {
    const user = getLoginUserDetails();
    if (!user) {
      return this.router.createUrlTree(['/auth/login']);
    }
    if (isOnboardingCompleteFromUser(user)) {
      return this.router.createUrlTree(getEssDashboardRoute());
    }
    return true;
  }
}
